const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Dominican Republic',
  code: 'DO',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    city: { label: 'Town', width: 0.5 },
    stateCode: { label: 'District' },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [['company'], ['address'], ['zipCode', SPACE, 'city']],
  formFormat: [['company'], ['address'], ['stateCode'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 11903'
    }
  ]
};
